import { flow, filter, map, max } from 'lodash/fp';
import safelyIncrement from './safelyIncrement';

const uniqueNewName = (templateName, existingNames) => {
  const largestExistingNum = flow(
    filter(n => n.match(new RegExp(`^${templateName.replace('{{num}}', '\\d*')}$`, 'ig')) !== null),
    map(n => Math.round(parseInt(n.replace(/\D*/g, '')))),
    max,
  )(existingNames);

  const nextNumber = safelyIncrement(largestExistingNum);

  const nextName = templateName.replace('{{num}}', nextNumber);

  return nextName;
};

export default uniqueNewName;
